import {Component} from '@angular/core';
import {Field} from '../../../../model/field.model';
import {ActivatedRoute, Router} from '@angular/router';
import {StateService} from '../../../../state.service';
import {Tree} from '../../../../model/tree.model';
import {Line} from '../../../../model/line.model';
import {Sponsor} from '../../../../model/sponsor.model';

@Component({
    selector: 'app-edit-tree',
    templateUrl: './edit-tree.component.html',
    styleUrls: ['./edit-tree.component.css'],
    standalone: false
})
export class EditTreeComponent {
  field: Field;
  line: Line;
  tree: Tree;
  submitted = false;
  treeTypes = ['Atlas-Zeder', 'Buche', 'Flaumeiche', 'Hänge-Birke', 'Haselbaum', 'Haselstrauch', 'Kiefer', 'Steineiche',
    'Stieleiche', 'Winterlinde'];
  truffleTypes = ['Burgunder', 'Perigordtrüffel', 'Wintertrüffel', 'Frühlingstrüffel', 'Teertrüffel', 'Grosssporigetrüffel'];
  sponsors: Sponsor[];

  constructor(private route: ActivatedRoute, private router: Router, private stateService: StateService) {
    if (!this.stateService.tree) {
      this.router.navigate( ['field']);
    }
    this.field = this.stateService.field;
    this.line = this.stateService.line;
    this.tree = this.stateService.tree;
    this.sponsors = this.stateService.getSponsors();
  }

  onSubmit() {
    this.stateService.updateTree(this.tree);
    this.submitted = true;
    this.router.navigate( ['/field/' + this.field.id + '/line/' + this.line.id + '/tree/' + this.tree.id]);
  }

  onSponsorChange(value: Sponsor | '') {
    if (!value) {
      this.tree.sponsor = undefined;
      this.tree.sponsorSince = undefined;
      return;
    }
    if (!this.tree.sponsorSince) {
      const today = new Date();
      const iso = new Date(today.getTime() - today.getTimezoneOffset() * 60000).toISOString().substring(0, 10);
      this.tree.sponsorSince = iso;
    }
  }

}
